/* eslint-disable */
import React, { Component } from 'react';

import MConfig      from './../../moramma-config.json';
import Aux from '../../hoc/Aux';
import Classes from './OnlineSongCast.css';
import ReactSpeedometer from "react-d3-speedometer"
import axios        from 'axios';
import lang from '../../lang.json';

class OnlineSongCast extends Component {

  // eslint-disable-next-line keyword-spacing
  // eslint-disable-next-line space-infix-ops
  fmtMSS = (s) => {return(s-(s%=60))/60+(9<s?':':':0')+s}

  state = {
    keepstatus : 50,
    skipRequired: 4,
    skipBannerCounter: 60,
    showSkipBanner: false,
    keepRequired: 0,
    listeningSkip: true,
    minSongduration: 30,
    songToSkip: null,
    userData: null,
    continueTimer: true,
    isSongChanged: false,
    isMinSongTimeFinish: false,
    showSkipRemainSecondsBanner: false,
  }


  // this functions start a trimmer for this.state.skipBannerCounter seconds
  startSkipTimerBanner = () => {
    const remaningSeconds = this.state.skipBannerCounter;
    if(remaningSeconds <= 0) {

      // dismiss the skip banner
      this.setState({ showSkipBanner: false });

      if(this.props.songs && !this.state.isSongChanged) {
        // enter here if there is a next song to propose
        // if the song is not changed (e.g. from mangerscreen)
        const song = this.props.songs[0];

        // TODO: missing 1.30 minium secdon song played
        this.skipsong(song);
        this.setState({ listeningSkip: true, skipBannerCounter: 60});
      }/* else {
        console.log('else startskip', this.state.minSongduration);
        this.setState({ showSkipRemainSecondsBanner: true });
        // setTimeout(this.startSkipTimerBanner, 1000);
      }*/
    } else {
      console.log(`skip timer triggered. Remaning ${remaningSeconds}`);
      this.setState({ skipBannerCounter: remaningSeconds -1});

      if(this.state.continueTimer) {
        setTimeout(this.startSkipTimerBanner, 1000);
      }
    }
  }

 /* startSongMinDurationBanner = () => {
   
    const remaningSeconds = this.state.minSongduration;
    console.log('*****called******', remaningSeconds);
    if(remaningSeconds <= 0) {
      // song can be skipped
      this.setState({isMinSongTimeFinish: true});
    } else {
      // console.log(`timer minsong. Remaning ${remaningSeconds}`);
      this.setState({ minSongduration: remaningSeconds -1});

      if(this.state.continueTimerDuration) {
        setTimeout(this.startSongMinDurationBanner, 1000);
      }
    }
  */

  async componentDidMount() {
    await this.fetchUserData();
    // this.startSongMinDurationBanner();
  }

  componentWillReceiveProps = (newProps) => {
    this.setState({isSongChanged: false});

    // TODO: on page reload unbale to restore song keep skip status
    if((newProps.actions && newProps.actions.length > 0) && this.state.listeningSkip) {
    
      let tmpkeep = this.state.keepRequired;
      if(newProps.actions && (newProps.actions[0].kindOfVote === "keep")) {
        // counter for keep required during skip counter banner
        tmpkeep = tmpkeep - 1;
        this.setState({ keepRequired: tmpkeep });

        // run the skip checker algorithm
        this.runKeepSkipAlgorithm(newProps.actions[0].song);
      }
      else if(newProps.actions && (newProps.actions[0].kindOfVote === "skip")) {

        // counter for keep required during skip counter banner
        tmpkeep = tmpkeep + 1;
        this.setState({ keepRequired: tmpkeep });

        this.runKeepSkipAlgorithm(newProps.actions[0].song);
      }
      else if(newProps.actions[0].kindOfVote === "onAir") {
        // reset state when a new song is forced online (e.g. from maangerscreen)

        console.log('reciving new action', newProps);

        this.setState({
          keepstatus : 50,
          skipRequired: 4,
          skipBannerCounter: 60,
          showSkipBanner: false,
          keepRequired: 0,
          listeningSkip: true,
          continueTimer: true,
          isSongChanged: true,
        })
      }

      // this.startSongMinDurationBanner();
    }else if ((newProps.actions && newProps.actions.length > 0) && !this.state.listeningSkip) {
      let tmpkeep = this.state.keepRequired;
      console.warn('newProps.actions !listening', newProps);
      if(newProps.actions[0].kindOfVote === "keep") {
        tmpkeep = tmpkeep - 1;
        this.setState({ keepRequired: tmpkeep, isSongChanged: false });
      }
      else if(newProps.actions[0].kindOfVote === "skip") {
        tmpkeep = tmpkeep + 1;

        this.setState({ keepRequired: tmpkeep, isSongChanged: false });
      }
      else if(newProps.actions[0].kindOfVote === "onAir") {
        // reset state when a song is forced online (e.g. from managerscreen)
        this.setState({
          keepstatus : 50,
          skipRequired: 4,
          skipBannerCounter: 60,
          showSkipBanner: false,
          keepRequired: 0,
          listeningSkip: true,
          continueTimer: true,
          isSongChanged: true
        })
      }

    //  console.log('loooooo', this.state.keepRequired);
      if(tmpkeep <= 0) {
        // canzone viene salvata dallo skip
        this.setState({ showSkipBanner: false, continueTimer: false, isSongChanged: false, continueTimerDuration: false });
       // console.log('loooooo ANNULLATO', this.state.keepRequired);
      }
    }
  }

  runKeepSkipAlgorithm = (song) => {
    //  console.log('entrato');
    // calcolo la solia di skip
    let threshold = (song.unlike + song.like) * 0.75;

    // imposto una solia base di almeno 4
    if(threshold < 4) {
      threshold = 4;
    }

    // calcolo il passo base di quanto muovere la progressbar (da 50 a 100)
    // lo 0 virtuale è 50 poichè con i keep diminuisce
    const baseStep = 50/threshold; 

  //  console.log('keep', song.keep);
  //  console.log('skip', song.skip);
  //  console.log('passo', baseStep);
   
    // prima mi muovo verso i keep
    const intermediateStatus = 50 + (song.keep * baseStep);

    // torno in dietro dei skip
    const actualStatus = intermediateStatus - (song.skip * baseStep);

    const skipRequired = Math.round(actualStatus / baseStep);

    if(skipRequired <= 0) {
      // console.log('entrato1');
      this.setState({ listeningSkip: false, showSkipBanner: true, keepstatus: 0, skipRequired: 0, songToSkip: song,  blockSkip: false });
      this.startSkipTimerBanner();
    }

    if(actualStatus) {
     // console.log('entrato2');
      this.setState({keepstatus:actualStatus, skipRequired: skipRequired, blockSkip: false});
    }
  }

  fetchUserData = async () => {
    const localtoken = localStorage.getItem('API');
    if(!localtoken) {
        return this.setState({ logged: false });
    }

    await axios({
        method: 'post',
        url: `${MConfig['BASE_API']}/react/user`,
        headers: {
            "Authorization" : `Bearer ${localtoken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        data: { token: localtoken }
    }).then(async items => {
        this.setState({ roomName: items.data.data.location.name, userData: items.data.data.location })         
    });
  }

  skipsong = async (song) => {
    console.log('skipsong', song);
    const localtoken = localStorage.getItem('API');
    if (!localtoken) {
      logger.error('[ManagerScreen|skipSong] Local token not found');
      this.logOut();
    }

    console.log('calling axios', this.state.userData);
    await axios({
      method: 'put',
      url: `${MConfig.BASE_API}/rooms/${this.state.roomName}/songs/${song.id}/online`,
      headers: {
        Authorization: `Bearer ${localtoken}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      data: { token: localtoken, user: this.state.userData }
    }).then(() => {
      console.log('ok');
    }).catch(err => {
      logger.error('[ManagerScreen|skipSong] error during API/rooms/x/songs/x/online', err);
      console.log('res', err);
    });

    console.log('finish');
  }
  

  render() {
    let like = '';
    let user = '';
    let userpic = '.';    
    let songImage = '';
    let songTitle = '';
    let songAuthor = '';

    if (this.props.song) {
      like = this.props.song.like;
      user = this.props.song.user.name;
      songTitle = this.props.song.name;
      songAuthor = this.props.song.artist;
      songImage = this.props.song.cover;
      if (this.props.song.user.picture) {
        userpic = this.props.song.user.picture;
      }
    }

    return (    
      <Aux>
        <div className="container">
        <div className="d-flex flex-fill flex-row  justify-content-between align-content-center align-self-center">
          <img 
            src={`${songImage}?auto=compress&cs=tinysrgb`}
            className={[Classes.SongImage, 'img-responsive'].join(' ')}
            alt={songImage}
            title={songImage}
          />  

              <div className={`align-self-center ${Classes.TxtCenter}`}>
                <h5 className={Classes.SongTitle}>
                  {songTitle.substring(0, 20)}
                </h5>
                <h5 className={Classes.SongAuthor}>{songAuthor}</h5>
                <hr className={Classes.SongRedSeparator} />
                <h5 className={Classes.SongAuthor}> ♥ {like}</h5>
              </div>

        <div className={`${Classes.RightAlign}`}>
          {
              userpic[0] === '.'
              
                ? (
                  <div>
                    <img 
                      src={require('../../assets/svg/anon-user.svg')}
                      className={[Classes.SongUserAnon, 'img-responsive'].join(' ')}
                      alt="User"
                      title="User"
                    />
                  </div>
                )   
                : (
                  <div>
                    <img 
                    src={`${userpic}`}
                    className={[Classes.SongUserAnon, 'img-responsive'].join(' ')}
                    alt="User"
                    title="User"
                  />
                  </div>
                )
              }
              <h5 className={Classes.Title}>{lang[this.props.language].pbscreen_os_proposedby} <br /> {user}</h5>
          </div>
        </div>
        </div>
        
        
        
      </Aux>
    );
  }
}

export default OnlineSongCast;
